export const WHOLESALER_ADD_REQUEST = "WHOLESALER_ADD_REQUEST";
export const WHOLESALER_ADD_SUCCESS = "WHOLESALER_ADD_SUCCESS";
export const WHOLESALER_ADD_FAILURE = "WHOLESALER_ADD_FAILURE";

export const WHOLESALER_EDIT_REQUEST = "WHOLESALER_EDIT_REQUEST";
export const WHOLESALER_EDIT_SUCCESS = "WHOLESALER_EDIT_SUCCESS";
export const WHOLESALER_EDIT_FAILURE = "WHOLESALER_EDIT_FAILURE";

export const WHOLESALER_VIEW_REQUEST = "WHOLESALER_VIEW_REQUEST";
export const WHOLESALER_VIEW_SUCCESS = "WHOLESALER_VIEW_SUCCESS";
export const WHOLESALER_VIEW_FAILURE = "WHOLESALER_VIEW_FAILURE";

export const WHOLESALER_VIEW_ALL_REQUEST = "WHOLESALER_VIEW_ALL_REQUEST";
export const WHOLESALER_VIEW_ALL_SUCCESS = "WHOLESALER_VIEW_ALL_SUCCESS";
export const WHOLESALER_VIEW_ALL_FAILURE = "WHOLESALER_VIEW_ALL_FAILURE";

export const WHOLESALER_SEARCH_REQUEST = "WHOLESALER_SEARCH_REQUEST";
export const WHOLESALER_SEARCH_SUCCESS = "WHOLESALER_SEARCH_SUCCESS";
export const WHOLESALER_SEARCH_FAILURE = "WHOLESALER_SEARCH_FAILURE";

export const WHOLESALER_DELETE_REQUEST = "WHOLESALER_DELETE_REQUEST";
export const WHOLESALER_DELETE_SUCCESS = "WHOLESALER_DELETE_SUCCESS";
export const WHOLESALER_DELETE_FAILURE = "WHOLESALER_DELETE_FAILURE";

export const WHOLESALER_RESET_STATE = "WHOLESALER_RESET_STATE";
